export default __webpack_public_path__ + "static/media/whistle.3b158cdd.png";